import Cookies from 'js-cookie';
import { Translate } from '$common';

export const saveDraft = (data) => {
  const draftExpiration = 365; // Day
  const oldData = Cookies.get('project');
  const newData = JSON.stringify(data);
  let message = { message: Translate.get('waiting_for_new_changes') };

  // If there is a difference then save
  if (newData !== oldData) {
    Cookies.set('project', newData, { expires: draftExpiration });
    message = { "message": Translate.get('all_changes_saved') }
  }

  return message
}

export const getDraft = () => {
  return Cookies.get('project') && JSON.parse(Cookies.get('project'));
}

export const deleteDraft = () => {
  Cookies.remove('project');
}



// WEBPACK FOOTER //
// ./src/lib/draft-manager.js